import { useCallback } from 'react'
import { PaginationResponse, useAppDispatch } from '@/state'
import {
  PlayerCardActions,
  PlayerCardModels,
  PlayerCardThunks,
} from '@/state/player-card'

export const usePlayerSearchActions = () => {
  const dispatch = useAppDispatch()

  const getPlayersSearch = useCallback(
    (filters: PlayerCardModels.SelectedFiltersType) => {
      dispatch(PlayerCardThunks.getPlayersThunk(filters))
    },
    [dispatch],
  )

  const setPlayerPagination = useCallback(
    (pagination: PaginationResponse) =>
      dispatch(PlayerCardActions.setPlayerCardPaginationAction(pagination)),
    [dispatch],
  )

  return {
    getPlayersSearch,
    setPlayerPagination,
  }
}
